import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { StorageService } from '../storage/storage.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  CTNRedirect: BehaviorSubject<boolean> = new BehaviorSubject(false)


  constructor(
    private httpService: HttpService,
    private storageService: StorageService
  ) {}

  doLogin(data: object) {
    return this.httpService.loginPostWithoutToken('authenticate', data);
  }

  doLoginUser(data: object) {
    return this.httpService.loginPostWithoutToken('authenticate-fa', data);
  }

  doLogout(): void {
    this.storageService.setToken('')
    this.storageService.setTokenExtern('')
    this.storageService.setRole('')

    this.storageService.clear();
  }

  isAuthenticated(): boolean {
    return this.storageService.isAuthenticated();
  }

  getMyRol(): Promise<any> {
    return this.httpService.post('admin/users/getRole');
  }

  /**
   * Store-role users tied to a non-active store must not complete login in the SPA.
   * Backend should still reject tokens / APIs for inactive stores; this is UX + client session hygiene.
   */
  isStoreUserWithInactiveStore(authPayload: {
    role?: string;
    store?: { status?: string } | null;
  }): boolean {
    if (authPayload?.role !== 'store' || !authPayload.store) {
      return false;
    }
    const status = (authPayload.store.status ?? '').toString().toLowerCase();
    return status === 'inactive' || status === 'disabled';
  }



  setCTNRedirect(value:boolean){
    this.CTNRedirect.next(value)
  }

  getCTNRedirect(): Observable<boolean>{
    return this.CTNRedirect
  }



}
